import { Pipe, PipeTransform } from '@angular/core'
import { TimezoneOption } from 'projects/commons/src/lib/types/timezone'

// convert time to specified timezone, or default to UTC
//  see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
//  for timezone names and offsets

// Intl.DateTimeFormat cheatsheet
// https://devhints.io/wip/intl-datetime

@Pipe({
  name: 'time',
})
export class TimePipe implements PipeTransform {
  transform(
    value: string | number | Date,
    includeSeconds = false,
    timezone = 'UTC',
    timezoneOption: TimezoneOption = 'UTC',
    includeTimezone = true,
  ): string {
    if (!value) {
      return ''
    }
    let displayTimezone = 'UTC'
    if (timezoneOption === 'LOCAL') {
      // use browser local timezone
      displayTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    } else if (timezoneOption === 'PLANT' && timezone) {
      displayTimezone = timezone
    }

    const dt = new Date(value)
    if (dt.toString() == 'Invalid Date') {
      return ''
    }
    const options: any = {
      hour: 'numeric',
      minute: 'numeric',
      timeZone: displayTimezone,
    }
    if (includeSeconds) {
      options.second = 'numeric'
    }
    if (includeTimezone) {
      options.timeZoneName = 'short'
    }
    const formatted = new Intl.DateTimeFormat('en-GB', options).format(dt)
    // Chrome 154+ (newer ICU) renders zero-offset zones like Europe/London in
    // winter as "GMT+0" rather than "GMT" - normalise so output is consistent
    // across browsers
    const intlRet = formatted.replace(/GMT\+0(?![\d:])/, 'GMT')

    return intlRet
  }
}
